module.exports = __webpack_public_path__ + "static/media/gucci-guilty-big.6f479699.png";